// @flow
// Rules
export const ALL_DIVISIONS = 'ALL_DIVISIONS';
export const STAY_LIMIT = 'StayLimit';
export const STAY_LIMIT_PER_LEG = 'StayLimitPerLeg';
export const HIGH_USE_DIVISION_DURATIONS_TARGET = 'HighUseDivisionDurations';
export const HIGH_USE_RESERVATION_DURATION_TARGET = 'HighUseReservationDuration';
export const MAX_ALTERNATE_LEADERS = 'MaxAlternateLeaders';
export const MIN_GROUP_SIZE = 'MinGroupSize';
export const MAX_GROUP_SIZE = 'MaxGroupSize';
export const MAX_WATERCRAFT_PER_RESERVATION = 'MaxWatercraftPerReservation';
export const MIN_VEHICLES = 'MinVehicles';
export const MAX_VEHICLES = 'MaxVehicles';
export const MIN_VEHICLES_PER_RESERVATION = 'MinVehiclesPerReservation';
export const MAX_VEHICLES_PER_RESERVATION = 'MaxVehiclesPerReservation';
export const ONLINE_PRINTING = 'OnlinePrinting';
export const SAME_DAY_DEAD_LINE = 'SameDayDeadLine';
export const EXTERNAL_MODIFICATION_DEADLINE = 'ExternalModificationDeadline';
export const QUOTA_USAGE_BY_MEMBER = 'QuotaUsageByMember';
export const QUOTA_USAGE_BY_MEMBER_DAILY = 'QuotaUsageByMemberDaily';
export const CONSTANT_QUOTA_USAGE_DAILY = 'ConstantQuotaUsageDaily';
export const CONSTANT_QUOTA_USAGE_BY_START_DATE = 'ConstantQuotaUsageByStartDate';
export const MODIFICATION_DEADLINE = 'ModificationDeadline';
export const CANCELLATION_DEADLINE = 'CancellationDeadline';
export const STAY_MINIMUM = 'StayMinimum';
export const LOTTERY_PREFERENCES_TYPE = 'LotteryPreferencesType';
export const LOTTERY_PREFERENCE_SELECTION_LIMIT = 'LotteryPreferenceSelectionLimit';
export const MAX_STOCK = 'MaxStock';
export const INCREMENT_EXIT_DATE = 'IncrementExitDate';

// Rule Targets
export const PEOPLE_AND_STOCK = 'PeopleAndStock';
export const PEOPLE_AND_PETS = 'PeopleAndPets';


// RECEIVED FROM BE BUT NOT USED YET
export const ALLOW_ANIMALS = 'AllowAnimals';
export const MUST_ENTER_ANIMALS = 'MustEnterAnimals';
export const CANNOT_MODIFY_ALT_PERMIT_HOLDERS = 'CannotModifyAltPermitHolders';
export const CANNOT_MODIFY_DIVISION_ID = 'CannotModifyDivisionID';
export const CANNOT_MODIFY_START_DATE = 'CannotModifyStartDate';
export const MODIFY_PERMIT_HOLDER = 'ModifyPermitHolder';
export const QUOTA_ROLLUP_WINDOW = 'QuotaRollupWindow';
export const ALTERNATE_PERMIT_HOLDER_STRICT = 'AlternatePermitHolderStrict';
export const MAX_PARTY_SIZE = 'MaxPartySize';

// Default rule values
export const DEFAULT_STAY_LIMIT = 365;
export const DEFAULT_STAY_LIMIT_PER_LEG = 14;
export const DEFAULT_MAX_ALTERNATE_LEADERS = 1;
export const DEFAULT_MIN_GROUP_SIZE = 1;
export const DEFAULT_MAX_GROUP_SIZE = 99;
export const DEFAULT_MAX_WATERCRAFT = 99;
export const DEFAULT_MIN_VEHICLES = 0;
export const DEFAULT_MAX_VEHICLES = 99;
export const DEFAULT_ONLINE_PRINTING = 14;
export const DEFAULT_MAX_STOCK = 99;
export const DEFAULT_LOTTERY_PREFERENCE_SELECTION_LIMIT = 4;

// lottery preferences enum
export const LOTTERY_PREFERENCE_TYPES = {
  DATE: 1,
  DATE_DIVISION: 2,
  DATE_DIVISION_DURATION: 3,
  DATE_DIVISION_GROUP_MIN_MAX: 4,
  DATE_DIVISION_GROUP_MAX: 5,
  DATE_RANGE_GROUP_SIZE: 6,
};

export const RuleTypes = {
	Available: 0,
	RegistrationSeason: 1,
	LotterySeason: 2,
	Reservation: 3,
	Modification: 4,
	LotteryCancellation: 5,
	PermitCancellation: 6,
	Fee: 7,
	Lottery: 8,
	Quota: 9,
	Visibility: 10,
	QuotaConversion: 11,
	QuotaModification: 12,
	PreliminaryReservation: 13,
}
